// extracted by mini-css-extract-plugin
module.exports = {"productTile":"ProductSlider_productTile__N_I_Y"};